import PropTypes from 'prop-types';
import Skeleton from 'components/common/TextSkeleton';
import { ReadOnlyFormControl } from 'components/common/fields';
import { loadById } from 'model/internalAccount';
import { selectorId } from 'selectors/internalAccount';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import LoanNumberMask from '../LoanNumberMask';

const AutopayPalPayFrom = ({ ddaId, fspId, payerId }) => {
  const dispatch = useDispatch();
  const account =
    useSelector((state) => selectorId(state, { payerId, id: ddaId })) || {};
  const { accountNbrMask } = account;

  useEffect(() => {
    if (ddaId && !accountNbrMask) {
      dispatch(loadById({ fspId, id: ddaId }));
    }
  }, [dispatch, accountNbrMask, ddaId, fspId]);

  return (
    <ReadOnlyFormControl
      inputNode={
        accountNbrMask ? (
          <LoanNumberMask fspId={fspId} item={account} />
        ) : (
          <Skeleton />
        )
      }
      label="Pay From Account"
      value={accountNbrMask || <Skeleton />}
    />
  );
};

AutopayPalPayFrom.propTypes = {
  ddaId: PropTypes.number.isRequired,
  fspId: PropTypes.number.isRequired,
  payerId: PropTypes.number.isRequired,
};

export default AutopayPalPayFrom;
